<template>
  <main class="login-content">
    <slot />
  </main>
</template>

<script lang="ts" setup>

</script>

<style>
.login-content {
  display: flex;
  justify-content: center; 
  align-items: center; 
  height: 100vh;
  width: 100vw;
}
</style>